/**
 * El formato de intercambio de cuestionarios (§10.1 del documento de especificación).
 *
 * Está pensado para que lo escriba **un modelo de lenguaje**, y eso condiciona el diseño: casi
 * todo es opcional y hereda, los campos que no se reconocen se ignoran, y **nada de lo que llega
 * se considera de fiar**, ni siquiera para mostrarlo en la vista previa.
 */
import { z } from 'zod';
import { CLICA_FORMAT_VERSION } from '../constants.js';
/** Hasta aquí llega un archivo razonable. Cinco veces el caso de uso, que son veinte preguntas. */
export const MAX_QUESTIONS_PER_FILE = 100;
/** Un megabyte de texto son muchas más preguntas de las que caben en una clase. */
export const MAX_FILE_BYTES = 1_048_576;
const optionSchema = z
    .object({
    text: z.string(),
    correct: z.boolean().optional(),
})
    // Lo que no se reconoce se ignora en lugar de rechazar el archivo (RF-010).
    .loose();
const questionSchema = z
    .object({
    /** Opcional: si no viene, se asume el tipo por defecto de la plataforma. */
    type: z.string().optional(),
    prompt: z.string(),
    hint: z.string().optional(),
    time_limit_s: z.number().int().positive().optional(),
    hint_after_s: z.number().int().nonnegative().optional(),
    shuffle_options: z.boolean().optional(),
    points_multiplier: z.number().positive().optional(),
    options: z.array(optionSchema),
})
    .loose();
const settingsSchema = z
    .object({
    time_limit_s: z.number().int().positive().optional(),
    shuffle_questions: z.boolean().optional(),
    shuffle_options: z.boolean().optional(),
    allow_alias: z.boolean().optional(),
    hints_enabled: z.boolean().optional(),
    auto_advance: z.boolean().optional(),
    auto_advance_delay_s: z.number().int().nonnegative().optional(),
})
    .loose();
export const exchangeFileSchema = z
    .object({
    clica_format: z.number().int(),
    /** Solo aparece al exportar; al importar se ignora. */
    exported_at: z.string().optional(),
    quiz: z
        .object({
        title: z.string(),
        description: z.string().optional(),
        settings: settingsSchema.optional(),
        questions: z.array(questionSchema),
    })
        .loose(),
})
    .loose();
/** La versión que esta plataforma sabe leer y escribir. */
export const SUPPORTED_FORMAT_VERSION = CLICA_FORMAT_VERSION;
//# sourceMappingURL=schema.js.map